import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LandingPage from "./components/Landing";
import Login from "./components/auth/Login";
import {
  VerifyEmail,
  VerifyEmailSuccess,
  VerifyEmailMessage,
} from "./components/auth/VerifyEmail";
import Register from "./components/auth/Register";
import {
  ForgetPassword,
  // ForgetPasswordSentEmail,
} from "./components/auth/ForgetPassword";
// import {
//   ResetPassword,
//   ResetPasswordSuccess,
// } from "./components/auth/ResetPassword";
import DashBoard from "./components/pages/dashboard/DashBoard";
import Report from "./components/pages/report/Report";
import Profile, { Extension } from "./components/pages/profile/Profile";
import Maps from "./components/pages/maps/Maps";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import RedirectMobileApp from "./components/pages/RedirectMobile";
import { GetAccessToken } from "./api/auth/Authentication";
// import "mapbox-gl/dist/mapbox-gl.css";
import "maplibre-gl/dist/maplibre-gl.css";
import PrivacyPolicy from "./components/auth/PrivacyPolicy";
import TermsCondition from "./components/auth/Condition";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NavbarProvider } from "./context/NavBarContext";
import { FilterMapProvider } from "./context/FilterMapContext";
import UserPolicy from "./components/auth/UserPolicy";
import UserTermsCondition from "./components/auth/UserCondition";
import LoadingPage from "./components/common/Loading";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import { UserProvider } from "./context/user-context";

export interface UserDataType {
  user: User;
  accessToken: string;
  tokenType: string;
  expiresIn: number;
  expiredAt: string;
  refreshToken: string;
}
export interface User {
  id: string;
  accountType: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  avatar: string;
  role: string;
  verified: boolean;
  enabled: boolean;
  lastLogin: string;
  identityProvider: IdentityProvider;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  extension: Extension;
}
export interface IdentityProvider {
  google: Google;
}
export interface Google {
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  hd: string;
  id: any;
  locale: string;
  name: string;
  picture: string;
  sub: string;
}

function IndexRoute() {
  const refresh_token = localStorage.getItem("refresh_token");
  const user = localStorage.getItem("user");
  const accessToken = localStorage.getItem("access_token");
  const navigate = useNavigate();

  const handleCheckToken = async () => {
    if (accessToken && user) {
      // navigate("/");
    } else {
      if (refresh_token) {
        try {
          let payload = {
            grant_type: "refresh_token",
            refresh_token: refresh_token,
          };

          const data: UserDataType = (await GetAccessToken(
            payload
          )) as UserDataType;
          if (data) {
            let user = {
              id: data.user.id,
              firstName: data.user.firstName,
              lastName: data.user.lastName,
              email: data.user.email,
              role: data.user.role,
            };
            let userJson = JSON.stringify(user);
            localStorage.setItem("user", userJson);
            localStorage.setItem("refresh_token", refresh_token);
            localStorage.setItem("access_token", data.accessToken);
            localStorage.setItem("token_type", data.tokenType);
            localStorage.setItem("expired_at", data.expiredAt);
            localStorage.setItem("uid", data.user.id);
            navigate(`/dashboard`);
          }
        } catch (error: any) {
          console.log(error);
          localStorage.removeItem("user");
          localStorage.removeItem("access_token");
          localStorage.removeItem("token_type");
          localStorage.removeItem("expired_at");
          localStorage.removeItem("refresh_token");
          navigate("/login");
        }
      }
    }
  };

  useEffect(() => {
    handleCheckToken();
  }, []);

  return (
    <>
      {user && accessToken ? (
        <>
          <AuthenticatedRoutes />
        </>
      ) : (
        <>
          <UnauthenticatedRoutes />
        </>
      )}
    </>
  );
}

function UnauthenticatedRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login">
        <Route index={true} element={<Login />} />
        <Route
          path="/login/verify"
          element={<VerifyEmail fromLogin={true} />}
        />
      </Route>
      <Route path="/register">
        <Route index={true} element={<Register />} />
        <Route
          path="/register/verify"
          element={<VerifyEmail fromLogin={false} />}
        />
      </Route>
      <Route path="/verify-email">
        <Route index={true} element={<VerifyEmailMessage />} />
        <Route path="/verify-email/success" element={<VerifyEmailSuccess />} />
        <Route
          path="/verify-email/fails"
          element={<VerifyEmail isFails={true} />}
        />
      </Route>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/term-condition" element={<TermsCondition />} />
      <Route path="/forgot-password" element={<ForgetPassword />} />
      <Route path="/redirect-auth" element={<RedirectMobileApp />} />
      <Route path="*" element={<Navigate to={"/login"} />} />
    </Routes>
  );
}

function AuthenticatedRoutes() {
  const { isLoading } = useLoading();
  return (
    <>
      {isLoading ? <LoadingPage /> : ""}
      <UserProvider>
        <App>
          <Routes>
            <Route path="/dashboard" element={<DashBoard />} />
            <Route
              path="/map"
              element={
                <FilterMapProvider>
                  <Maps />
                </FilterMapProvider>
              }
            />
            <Route path="/report" element={<Report />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/privacy-policy" element={<UserPolicy />} />
            <Route path="/term-condition" element={<UserTermsCondition />} />
            <Route path="*" element={<Navigate to={"/dashboard"} />} />
          </Routes>
        </App>
      </UserProvider>
    </>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LoadingProvider>
        <NavbarProvider>
          <IndexRoute />
          <ToastContainer />
        </NavbarProvider>
      </LoadingProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
